import React from "react";
import OrderTable from "../Table";

const PrescriptionAccepted = () => {
  return <OrderTable type="Prescription Accepted" />;
};

export default PrescriptionAccepted;
